<template>
    <div :id="`content-text-${data.id}`" class="content-text">
        <div class="content typography" v-html="props.data?.body" />
        <div v-if="!!data?.linksUrls.length" class="buttons">
            <UiLink v-for="(link, index) in data?.linksUrls" :key="index" :link="link" :style="'transparent w-border'" />
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
});
</script>
